import { ClearStore } from '../constants/actions';

export const actions = {
  [ClearStore]({ dispatch }) {
    dispatch('adminStore/clearStore');
    dispatch('ampStore/clearStore');
    dispatch('authStore/clearStore');
    dispatch('builderStore/clearStore');
    dispatch('popupStore/clearStore');
    dispatch('sidePanelStore/clearStore');
  },
};
